import filter from './filter'

export default
{
    filter
};
